// Define events for endofarticle & lazyload scripts.
(function (window, document, undefined) {
  ("use strict");

  let endOfArticle,
    logger = {};

  const eoaEvent = new Event('end_of_article');
  const premiumContent = document.querySelector(
    '.vodl-region-article__premium-content'
  );

  window.article = window.article || [];
  window.article.eoa = window.article.eoa || false;

  let rootMargin_eoa = window.innerHeight + 'px';
  let config_eoa = {
    rootMargin: rootMargin_eoa + ' 0px',
    threshold: 0.01,
  };

  let observer_eoa;

  // dispatches an event ('close_to_end_of_article') when close to article end (means two viewports).
  const intersectingEoa = (entries) => {
    let entry = entries[0];
    if (entry.isIntersecting) {
      logger.log(
        'EoaEvent - intersecting end of article \n',
        'rootMargin: ' + config_eoa.rootMargin
      );
      window.article.eoa = true;
      window.dispatchEvent(eoaEvent);
      observer_eoa.disconnect();
    }
  };

  // called when url contains hash.
  const jumpToEoa = () => {
    logger.log('jumpToEoa');
    if (endOfArticle.offsetTop <= window.scrollY && !window.article.eoa) {
      logger.log('jumpToEoa window.scrollY: ' + window.scrollY);
      window.article.eoa = true;
      window.dispatchEvent(eoaEvent);
      if ('undefined' !== typeof observer_eoa) observer_eoa.disconnect();
    }
  };

  const initPremiumEOA = () => {
    rootMargin_eoa = window.innerHeight + 'px';
    config_eoa = {
      rootMargin: rootMargin_eoa + ' 0px',
      threshold: 0.01,
    };
    observer_eoa = new IntersectionObserver(intersectingEoa, config_eoa);
    observer_eoa.observe(endOfArticle);
  };

  const initEOA = () => {
    observer_eoa = new IntersectionObserver(intersectingEoa, config_eoa);
    observer_eoa.observe(endOfArticle);
  };

  try {
    logger = new window.RussMedia.Utils.Logger('[eoa] ') || {
      log: function () {},
    };
  } catch (e) {
    logger = { log: function () {} };
  }

  endOfArticle = window.document.querySelector(
    '.vodl-region-article__content-bottom'
  );
  logger.log('end of article', endOfArticle);

  // If we don't have support for intersection observer,
  // set global window.article.eoa to true by default.
  // Otherwise start observing.
  if (!('IntersectionObserver' in window) || null === endOfArticle) {
    window.article.eoa = true;
  } else if (premiumContent) {
    // On premium articles check user status first.
    // When logged in, we have to wait for the content to get the correct values,
    // unless it's already there.
    let userStatus = window.RussMedia.Utils.LocalStorage.get('user-status');
    let paywalledContent = document.getElementsByClassName('paywalled-content')[0];
    if ( !userStatus.ssoId || undefined !== paywalledContent && 0 < paywalledContent.getElementsByTagName('*').length ) {
      logger.log('paid article - anonymous or the content\'s already there');
      initEOA();
    } else {
      logger.log('paid article - wait for content');
      window.addEventListener('vodl_show_full_content', initPremiumEOA);
    }
  } else {
    observer_eoa = new IntersectionObserver(intersectingEoa, config_eoa);
    observer_eoa.observe(endOfArticle);
  }

  if ('' !== window.location.hash) {
    window.addEventListener('load', jumpToEoa);
  }
})(window, document);
